import React from 'react';

function DataMonth(props) {
  const res = (props._data) ? props._data.filter((el) => el.id > 0) : 0;

  const clk = (id) => {
    props._clk(id);
  };

  const GridData = (props) => {
    const cl = ['free', 'n_period', 's_period', 'k_period', 'nk_period'];
    const cl_common = 'common';
    return props._data.days.map((it, index) => <div
      className={cl_common + ' ' + cl[it]} onClick={() => clk(props._data.clientID[index])} key={index}></div>);
  };

  return (
    <>
      {
        ((res) ?
          res.map((item, index) =>
            <div className="rec_calendar" key={index}>
              <div className="num_room common">
                {item.name_room}
              </div>
              <GridData _data={item}/>
            </div>
          )
          :
          <div></div>)
      }
    </>
  );
}

export default DataMonth;
